import { COOKIE_LANGUAGE_NAME, LanguageCode } from 'hah-fe-core/dist/constants';
import { Store } from './store';
import { getCookie } from 'hah-fe-core/dist/utils';

const apolloConfig = (lang?: LanguageCode) => {
  const locale = getCookie(COOKIE_LANGUAGE_NAME) as LanguageCode;
  return {
    uri: process.env.NEXT_PUBLIC_GRAPHQL_API_URL,
    locale: lang || locale,
    store: Store,
  };
};

export default apolloConfig;
